<ol>
	<li *ngFor="let stepLabel of stepsLabels; let i = index" [class.active]="i === activeStepIndex" [class.completed]="i < activeStepIndex">
		<div [dcrHTMLKey]="'WIZARD_STEP_' + i + '_TEXT'">{{ stepLabel }}</div>
	</li>
</ol>
